import { supabase, applyOrgFilter } from '../supabaseClient'
import { EMBED_RESPONSABLE, conResponsable } from '../familias'

const SELECT_FIELDS = `
  id,
  org_id,
  familia_id,
  jugador_id,
  monto_total,
  fecha_pago,
  metodo_pago,
  referencia,
  notas,
  comprobante_path,
  estatus,
  rechazo_razon,
  revisada_por,
  revisada_en,
  transaccion_id,
  replaces_solicitud_id,
  escaneo_estatus,
  escaneo_resultado,
  escaneado_en,
  created_at,
  familia:familias(id, nombre, ${EMBED_RESPONSABLE}),
  jugador:jugadores(id, nombre_completo, numero),
  cargos:pagos_solicitudes_cargos(
    cargo_id,
    monto_propuesto,
    pagos_cargos(
      id,
      monto_final,
      saldo,
      pagos_conceptos(nombre)
    )
  )
`

export const getSolicitudes = async ({ statuses = ['pendiente'], limit = 50, offset = 0 } = {}) => {
  try {
    let query = supabase
      .from('pagos_solicitudes_pago')
      .select(SELECT_FIELDS)
      .in('estatus', statuses)
      .order('created_at', { ascending: false })
      .range(offset, offset + limit - 1)
    query = applyOrgFilter(query)
    const { data: crudo, error } = await query
    const data = (crudo || []).map((s) => ({ ...s, familia: conResponsable(s.familia) }))
    if (error) throw error
    return { data: data || [], error: null }
  } catch (error) {
    console.error('[getSolicitudes]', error)
    return { data: [], error }
  }
}

export const getSolicitudesPendientesCount = async (orgId) => {
  try {
    const { count, error } = await supabase
      .from('pagos_solicitudes_pago')
      .select('id', { count: 'exact', head: true })
      .eq('org_id', orgId)
      .eq('estatus', 'pendiente')
    if (error) throw error
    return { count: count || 0, error: null }
  } catch (error) {
    console.error('[getSolicitudesPendientesCount]', error)
    return { count: 0, error }
  }
}

export const approveSolicitud = async (solicitudId, { transaccionPayload, staffId }) => {
  try {
    const { data, error } = await supabase.rpc('approve_solicitud_pago', {
      p_solicitud_id: solicitudId,
      p_transaccion: transaccionPayload,
      p_staff_id: staffId,
    })
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    console.error('[approveSolicitud]', error)
    return { data: null, error }
  }
}

export const rejectSolicitud = async (solicitudId, { razon, staffId }) => {
  try {
    const { error } = await supabase
      .from('pagos_solicitudes_pago')
      .update({
        estatus: 'rechazada',
        rechazo_razon: razon,
        revisada_por: staffId,
        revisada_en: new Date().toISOString(),
      })
      .eq('id', solicitudId)
    if (error) throw error
    return { data: { id: solicitudId }, error: null }
  } catch (error) {
    console.error('[rejectSolicitud]', error)
    return { data: null, error }
  }
}

export const getComprobanteSignedUrl = async (path, { downloadFilename } = {}) => {
  try {
    if (!path) return null
    const opts = downloadFilename ? { download: downloadFilename } : {}
    const { data, error } = await supabase.storage
      .from('pagos-comprobantes')
      .createSignedUrl(path, 300, opts)
    if (error) throw error
    return data?.signedUrl || null
  } catch (error) {
    console.error('[getComprobanteSignedUrl]', error)
    return null
  }
}
